module.exports = __webpack_public_path__ + "media/images/sp/top/recommend_plan_anchor_arrow-8cd14a89dff0020e6e4b97ba2bcb130c.svg";